import { ArrowUp } from "lucide-react";
import { SocialLinks } from "@/components/SocialLinks";
import { useSiteSettings } from "@/hooks/usePortfolio";
import { getImageUrl } from "@/api/client";

export const Footer = () => {
  const { data: siteSettings } = useSiteSettings();
  
  const toTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  return (
    <footer className="relative pt-20 pb-10 border-t border-[hsl(var(--border))] grain" data-testid="footer">
      <div className="container-x">
        <div className="grid md:grid-cols-3 gap-10 items-start">
          <div>
            <div className="flex items-center gap-3 mb-4">
              {siteSettings?.siteLogoUrl ? (
                <img src={getImageUrl(siteSettings.siteLogoUrl)} alt="Logo" className="w-10 h-10 object-contain" />
              ) : (
                <div className="w-10 h-10 rounded-full bg-gradient-to-br from-[hsl(var(--gold-light))] to-[hsl(var(--gold-deep))] flex items-center justify-center">
                  <span className="font-serif text-[hsl(var(--navy-deep))] font-bold text-sm">SR</span>
                </div>
              )}
              <div>
                <div className="font-serif text-lg">Shivaji Rajan M</div>
                <div className="text-[10px] uppercase tracking-[0.25em] text-muted-foreground">Business Leader</div>
              </div>
            </div>
            <p className="text-sm text-muted-foreground max-w-sm">{siteSettings?.metaDescription || ""}</p>
          </div>

          <div className="md:text-center">
            <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-4">Navigate</div>
            <div className="flex flex-wrap md:justify-center gap-x-5 gap-y-2 text-sm">
              {["About", "Expertise", "Experience", "Achievements", "Blogs", "Contact"].map((l) => (
                <a key={l} href={`#${l.toLowerCase()}`} className="hover:text-[hsl(var(--gold-deep))] dark:hover:text-[hsl(var(--gold-light))] transition-colors">{l}</a>
              ))}
            </div>
          </div>

          <div className="md:text-right">
            <div className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground mb-4">Connect</div>
            <div className="md:justify-end flex">
              <SocialLinks variant="inline" />
            </div>
          </div>
        </div>

        <div className="luxury-divider my-10"><span className="text-[10px] uppercase tracking-[0.3em] text-muted-foreground">SR</span></div>

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-muted-foreground">
          <div>{siteSettings?.footerText || `© ${new Date().getFullYear()} Shivaji Rajan. All rights reserved.`}</div>
          <button onClick={toTop} data-testid="back-to-top" className="inline-flex items-center gap-2 hover:text-[hsl(var(--gold-deep))] dark:hover:text-[hsl(var(--gold-light))] transition-colors">
            Back to Top <ArrowUp className="w-3 h-3" />
          </button>
        </div>
      </div>
    </footer>
  );
};
